<template>
  <div class="p-3">
    <h4 class="header-title mt-0 mb-1">{{ $t('function.form.information') }}</h4>
    <p class="sub-header"></p>

    <div class="row">

      <div class="col-12">

        <div class="form-group">
          <label for="" class="form-label">{{$t('function.form.name.label')}}</label>
          <input 
            type="text" 
            readonly="" 
            class="form-control-plaintext"
            v-model="model.name"
          >
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      model:{ },
    }
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    functionID() {
      let parameters = this.parameters || {}
      return parameters.functionID
    },
    submitted() {
      let parameters = this.parameters || {}
      return parameters.submitted
    },
  },
  methods: {
    fetchData() {
      let param = {}
      param.id = this.functionID

      return this.$store.dispatch('function/find', param)
      .then(res => {
        if (res && res.data) {
          this.model = res.data
        }
      })
    }
  },
  watch: {
    functionID: function () {
      this.fetchData()
    },
    submitted: function () {
      this.fetchData()
    }
  },
  mounted() {
    if (this.functionID) {
      this.fetchData()
    }
  }
}
</script>